import { getAccessToken } from "../authorization/AuthorizeService";
import { MessageContext } from "../message";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
export default function FetchButton({ href, text, className, fileToDownload }) {
  const { t } = useTranslation();
  const message = useContext(MessageContext);

  if (fileToDownload.content === "docx") {
    return (
      <button
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        onClick={async () =>
          fetch(`${process.env.REACT_APP_GATEWAY_URL}${href}`, {
            method: "GET",
            headers: {
              "Request-Origin": "pisarnica",
              Authorization: "Bearer " + (await getAccessToken()),
            },
            mode: "cors",
            credentials: "include",
          })
            .then((response) => response.blob())
            .then((file) => {
              const blob = window.URL.createObjectURL(file);
              const anchor = document.createElement("a");
              anchor.style.display = "none";
              anchor.href = blob;
              anchor.download = `${fileToDownload.label}.docx`;
              document.body.appendChild(anchor);
              anchor.click();
              window.URL.revokeObjectURL(blob);
            })
            .catch(() => console.log("Pogreška u preuzimanju datoteke"))
        }
      >
        {text}
      </button>
    );
  } else {
    return (
      <button
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        onClick={async () => {
          message.toggle({
            show: true,
            title: "",
            content: t("requests.wait.label"),
            hideNo: true,
            hideYes: true,
            isWait: true,
            hideX: false,
          });
          fetch(`${process.env.REACT_APP_GATEWAY_URL}${href}`, {
            method: "GET",
            headers: {
              "Request-Origin": "pisarnica",
              Authorization: "Bearer " + (await getAccessToken()),
            },
            mode: "cors",
            credentials: "include",
          })
            .then((response) => response.blob())
            .then(
              (file) => window.open(URL.createObjectURL(file)) && message.toggle({ show: false })
            );
        }}
      >
        {text}
      </button>
    );
  }
}
